import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { Label, TextField } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../../../utilities/i18n";

export type NameFormInputProps = {};

export const NameFormInput = ({}: NameFormInputProps) => {
  const { control } = useFormContext<{
    name: string;
  }>();

  const { t } = useTranslation("pos");

  return (
    <View>
      <Label required label={t("form.name.label")}></Label>
      <Controller
        name="name"
        control={control}
        render={({
          field: { onChange, value, onBlur },
          fieldState: { error },
        }) => (
          <TextField
            onBlur={onBlur}
            value={value ?? ""}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.name.placeholder")}
          />
        )}
      />
    </View>
  );
};
